import React, { Component } from "react";

import { connect } from "react-redux";

import "../../assets/css/custom.css";
import { tenant } from "../../Root";
import Delivery from "../Delivery";
import DeliveryDesktop from "../Delivery/DeliveryDesktop";

class App extends Component {

	componentDidMount() {
		localStorage.setItem("tenant",tenant);
	  
		if (localStorage.getItem("tenant") === tenant) {
			console.log("Tenant stored in localStorage");
			this.props.history.push("/");
			 
		} else {
			console.error("Failed to store tenant in localStorage");
		}
	}
	

	render() {
		return (
			<React.Fragment>
				{window.innerWidth <= 768 ? (
					<Delivery page={'new_orders'} />
				) : (
					<DeliveryDesktop languages={this.props.languages} />
				)}
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state) => ({
});

export default connect(
	mapStateToProps,
)(App);
